import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'plan_details',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      inext.insurance_plan_employers[props.index] = next
    })
  }
}
